class AddToCartMulti extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector("cart-drawer");
    this.addEventListener("click", this.onClickHandler.bind(this));
  }

  onClickHandler() {
    if (!this.dataset.bundleId) {
      console.error("data-bundle-id does not exist");
      return;
    }
    const variantIds = this.dataset.bundleId.split(",");
    const variantQtys = this.dataset.bundleQty?.split(",") || [];
    const target = this.dataset.target;

    if (variantIds.length) {
      var params = [];
      for (var i = 0; i < variantIds.length; i++) {
        params.push({
          id: variantIds[i],
          quantity: variantQtys[i] || 1,
        });
      }

      const items = {
        items: params,
      };

      if (document.body.classList.contains("template-cart")) {
        Shopify.postLink2(theme.routes.cart_add_url, {
          parameters: {
            ...items,
          },
        });
        return;
      }

      this.setAttribute("disabled", true);
      this.classList.add("loading");
      const sections = this.miniCart
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [];

      const body = JSON.stringify({
        ...items,
        sections: sections,
        sections_url: window.location.pathname,
      });

      fetch(`${theme.routes.cart_add_url}`, {
        ...fetchConfig("javascript"),
        body,
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:error", {
                detail: {
                  errorMessage: parsedState.description,
                },
              })
            );
          } else {
            if (target === "checkout") {
              window.location.href = "/checkout";
              return;
            }

            this.miniCart && this.miniCart.renderContents(parsedState);

            $(".drawer").removeClass("is-empty");

            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  product: parsedState,
                },
              })
            );
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.classList.remove("loading");
          this.removeAttribute("disabled");
        });
    }
  }
}
customElements.define("add-to-cart-multi", AddToCartMulti);
